interface Props {
  analystDescription: string;
  brokerDetail: string;
}

export default function SystemArchitecture({ analystDescription, brokerDetail }: Props) {
  return (
    <section className="system-panel architecture-panel">
      <div className="system-section-head">
        <div>
          <span className="system-kicker">HOW IT WORKS</span>
          <h2>현재 의사결정 구조</h2>
        </div>
        <span className="system-chip safe">주문 경로는 결정론적</span>
      </div>
      <div className="architecture-flow">
        <FlowStep label="전략 증거" detail="MA · RSI · VOL · MACD" />
        <span className="flow-arrow">→</span>
        <FlowStep label="Rule 판단" detail="BUY · HOLD · SELL" />
        <span className="flow-arrow">→</span>
        <FlowStep label="Risk Gate" detail="한도 · 손실 · 상태 검증" accent />
        <span className="flow-arrow">→</span>
        <FlowStep label="Broker" detail={brokerDetail} />
      </div>
      <div className="shadow-note">
        <strong>Analyst Shadow</strong>
        <span>{analystDescription}</span>
      </div>
    </section>
  );
}

function FlowStep({ label, detail, accent = false }: { label: string; detail: string; accent?: boolean }) {
  return (
    <div className={`flow-step${accent ? ' accent' : ''}`}>
      <strong>{label}</strong>
      <span>{detail}</span>
    </div>
  );
}
